<?xml version="1.0" encoding="UTF-8" standalone="no"?>

<svg
   width="2000"
   height="1456"
   viewBox="0 0 529.16665 385.23334"
   version="1.1"
   id="svg110"
   sodipodi:docname="top.svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview112"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     showgrid="false"
     units="px"
     showguides="false" />
  <defs
     id="defs107">
    <style
       type="text/css"
       id="style2"></style>
  </defs>
  <g
     id="layer9"
     style="display:none">
    <path
       style="fill:#ffffff;fill-opacity:1;stroke-width:0.264583;stop-color:#000000"
       d="M 0.3130169,98.785511 C 179.2647,25.915241 334.55716,20.549685 528.40791,97.748498"
       id="path6888"
       sodipodi:nodetypes="cc" />
  </g>
  <g
     id="layer2"
     style="display:inline">
    <text fill="red"
       xml:space="preserve"
       style="font-size:28.2222px;line-height:normal;font-family:my-custom-font;text-align:center;text-decoration-color:#000000;text-anchor:middle;display:inline;fill:#000000;stroke-width:0.264583;stop-color:#000000"
       id="text2971"
       transform="translate(0,-11.641667)"><textPath
         xlink:href="#path6888"
         startOffset="50%"
         id="textPath7379"
         style="font-weight:bold"></textPath></text>
  </g>
</svg>
